<template>
<div class="plans-button">
  <div class="text-container">
    <div class="tilted">חדש</div>
    <riseup-button :action="() => $emit('button-click')"
                   title="לתכנון התוכניות הגדולות שלי"
                   variant="secondary-black"
                   size="slim"
                   class="text" />
  </div>
</div>
</template>

<script>
import Segment from '@/Segment';
import BaseUi from 'base-ui';

export default {
  name: 'PlansButton',
  components: {
    RiseupButton: BaseUi.RiseupButton,
  },
  created() {
    Segment.trackUserGot('PlanAhead_AddPlans_Shown');
  },
};
</script>

<style scoped lang="scss">
@import '~../../../../../../scss/mixins';

.plans-button {
  padding: 0 24px 20px;
  cursor: pointer;

  .text-container {
    display: flex;
    position: relative;
    height: 55px;
    align-items: center;
    text-align: center;
    border-radius: 5px;
    margin-top: 17px;

    .text {
      width: 100%;
      border: 2px solid $riseup_black;
      padding: 0;
    }

    .tilted {
      background: $riseup_gray_0;
      color: $riseup_black;
      transform: rotate(-27deg);
      position: absolute;
      left: -10px;
      top: 0;
      width: 41px;
      height: 16px;
      font-weight: bold;
      font-size: 14px;
    }
  }
}
</style>
